import Api from '@/api/Api'

export default {
  fetchByParam (param) {
    return Api().post('OrderPax/fetch_by_param', param)
  }
}



// WEBPACK FOOTER //
// ./src/api/OrderPaxAPI.js